import { PRESELECTED_STORE_LOADING, PRESELECTED_STORE_SUCCESS } from "../actions/preselectedStore";

const defaultState = {
    isLoading: false,
    isError: false,
    isSuccess: false,
}

export const preselectedStoreState = (state = { ...defaultState }, action) => {
    switch (action.type) {
        case PRESELECTED_STORE_LOADING: return {
            isLoading: true,
            isError: false,
            isSuccess: false,
        }
        case PRESELECTED_STORE_SUCCESS: return {
            isLoading: false,
            isError: false,
            isSuccess: true,
        }
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/preselectedStore.js